export enum ProductPromotions {
    AfterCheckIn = 'AfterCheckIn',
    AfterCheckOut = 'AfterCheckOut',
    BeforeCheckIn = 'BeforeCheckIn',
    BeforeCheckOut = 'BeforeCheckOut',
    DuringCheckOut = 'DuringCheckOut',
    DuringStay = 'DuringStay',
    None = 'None',
}
